import { defineStore } from "pinia";
import { ref } from "vue";

import type { Id } from "@/model/baseTypes";
import type { Category } from "@/model/flexboard";
import { asSemiReadonly } from "@/utils/vue";

export const useCategoryStore = defineStore(
  "category",
  () => {
    const categories = ref<Category[]>([]);

    function update(payload: Id & { name?: string; position?: number }) {
      const i = categories.value.findIndex((c) => c.id === payload.id);
      if (i === -1) {
        return;
      }
      const cat = categories.value[i];
      if (payload.name !== undefined) {
        cat.name = payload.name;
      }
      if (payload.position !== undefined) {
        categories.value.splice(i, 1);
        categories.value.splice(payload.position, 0, cat);
      }
    }

    function clearFresh(id: string) {
      const cat = categories.value.find((c) => c.id === id);
      if (cat) {
        cat.fresh = false;
      }
    }

    function remove(e: Id) {
      const index = categories.value.findIndex((c) => c.id === e.id);
      if (index !== -1) {
        categories.value.splice(index, 1);
      }
    }

    function addBoard(e: { boardId: string; categoryId: string }) {
      const cat = categories.value.find((c) => c.id === e.categoryId)!;
      cat.boardIds.push(e.boardId);
    }

    function removeBoard(payload: { boardId: string; categoryId: string }) {
      const cat = categories.value.find((c) => c.id === payload.categoryId)!;
      const index = cat.boardIds.findIndex((b) => b === payload.boardId);
      if (index !== -1) {
        cat.boardIds.splice(index, 1);
      }
    }

    return {
      categories: asSemiReadonly(categories),
      categoryByName: (name?: string) => name && categories.value.find((c) => c.name === name),

      setCategories: (cats: Category[]) => (categories.value = cats),
      add: (id: string, name: string) =>
        categories.value.push({ id, name, boardIds: [], fresh: true }),
      clearFresh,
      update,
      remove,
      addBoard,
      removeBoard,
    };
  },
  { autoReset: true },
);
